import React, { useEffect } from 'react'
import { useDispatch, useSelector } from '../../store'
import { useParams } from 'react-router-dom'
import {
  LoadingTypes,
  isLoading as Loading,
  setTelemetryAuthType,
  usePartnerAccountDataActions,
  PartnerType,
} from '@labrav/common'
import { LoadingLogo } from '@labrav/react-components'

interface PartnerAccountDataProviderProps {
  children: React.ReactNode
  isExternal?: boolean
}

export const PartnerAccountDataProvider: React.FC<
  PartnerAccountDataProviderProps
> = ({ children, isExternal = false }) => {
  const dispatch = useDispatch()
  const { getAccount, loadAvailableAccounts } = usePartnerAccountDataActions()
  const { partnerId } = useParams<{
    partnerId?: string
  }>()

  const availableAccounts = useSelector(
    state => state.accountSelection.availableAccounts
  )
  const accountsLoading = useSelector<boolean>(state =>
    Loading(state.loading)(LoadingTypes.LOAD_AVAILABLE_ACCOUNTS)
  )
  useEffect(() => {
    if (partnerId && isExternal) {
      setTelemetryAuthType('external-app')
      dispatch(loadAvailableAccounts(partnerId) as never)
      dispatch(getAccount(partnerId as string, PartnerType.User) as never)
    }
  }, [partnerId, isExternal, dispatch, getAccount, loadAvailableAccounts])

  if (accountsLoading) {
    return (
      <div>
        <style>
          {`
      body.salesforce-canvas-dialog-form [data-testid="loading"] {
        height: 100vh !important;
      `}
        </style>
        <LoadingLogo />
      </div>
    )
  }
  return <>{children}</>
}
